import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { DepositContext, DepositResult } from '../../../../../../types/Cashier';
import { CardType } from '../../../../../../types/cardType';
import PayconiqTimeout from '../PayconiqTimeout/PayconiqTimeout';
import RejectedCommon from '../RejectedCommon/RejectedCommon';

import {
  TXTWCL_WeXll_email_you_once_itXs_been_ELL,
  TXTWCL_Your_payment_is_taking_longer__ELL_1
} from './Timeout.messages.json';

type Props = DepositResult & DepositContext;

const Timeout: React.FC<Props> = ({ deposit }) => {
  const isSwcPixQrCodeEnabled = useFeature(FeatureFlag.SwcPixQrCodeEnabled);

  return deposit?.type === CardType.Payconiq ||
    (deposit?.type === CardType.Pix && isSwcPixQrCodeEnabled) ? (
    <PayconiqTimeout />
  ) : (
    <RejectedCommon>
      <Translation {...TXTWCL_Your_payment_is_taking_longer__ELL_1} />{' '}
      <Translation {...TXTWCL_WeXll_email_you_once_itXs_been_ELL} />
    </RejectedCommon>
  );
};

export default Timeout;
